import type { SVGProps } from 'react';

const Validation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill="currentColor">
      <path d="M8.49 8.75a.749.749 0 1 0 1.5 0 .749.749 0 1 0-1.5 0Z" />
      <path
        fillRule="evenodd"
        d="M14.658 3.82 12 2 9.342 3.82l-3.22.09-1.08 3.035L2.49 8.91 3.4 12l-.91 3.09 2.552 1.965 1.08 3.035 3.22.09L12 22l2.658-1.82 3.22-.09 1.08-3.035 2.553-1.965L20.6 12l.91-3.09-2.553-1.965-1.08-3.035-3.22-.09ZM7.489 7h4.915l5.495 5.5-4.21 4.205c-.18.185-.705.71-.705.71l-5.495-5.5V7Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default Validation;
